import React, { useState } from "react";
import { FaCheck } from "react-icons/fa";
import useApi from "../../hooks/useApi";
import apiClient from "../../api/apiClient";
import { toast } from "react-toastify";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default () => {
  const { userId } = useSelector((state) => state.auth);
  const initialData = {
    user:userId,
    app_status: false,
    location_services: false,
    motion_and_fitness: false,
    app_notifications: false,
  };
  const [submitData, setSubmitData] = useState(initialData);
  const [id, setId] = useState("");
  const handleChange = (key, value) => {
    setSubmitData({
      ...submitData,
      [key]: value,
    });
  };

  const { request, loading, error } = useApi((submitData) =>
    apiClient.patch(`/settings/app_settings/${id}/`, submitData)
  );

  useEffect(() => {
    const fetch = async () => {
      const response = await apiClient.get("/settings/app_settings/");
     
      const data = response.data[0];
      console.log(data,"hus")
      setSubmitData(data);
      setId(data.id);
    };
    fetch();
  }, []);

  
  const handleSubmit = async (e) => {
    e.preventDefault();
   
    // const resul = await apiClient.post("/settings/app_settings/",submitData )
    const result = await request(submitData);

    
    if (result.ok) {
      toast.success("Setting Updated Succesfully");
      fetch();
    } else {
      toast.error("Error");
    }
  };
  return (
    <div>
      
      <form onSubmit={handleSubmit}>
        <div className="site-content h-100">
          <div className="p-4">
            <div className="site-content-body">
              <section className="notification-sec mt-4">
                <div className="container">
                  <div className="row notification-main d-flex justify-content-between">
                    <div className="col-lg-5  pe-lg-4">
                      <h3 className="notify-head blue-clr fs-3 fw-bold lh-base position-relative">
                        Location and Tracking
                      </h3>
                      <div className="mt-5">
                        <div className="mt-5">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="a_status"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              App Status
                            </label>
                            <input
                              checked={submitData?.app_status}
                              type="checkbox"
                              id="a_status"
                              className="notify-check"
                              onClick={(e) =>
                                handleChange("app_status", e.target.checked)
                              }
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="l_notification"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Location Services
                            </label>
                            <input
                              checked={submitData?.location_services}
                              type="checkbox"
                              id="l_notification"
                              className="notify-check"
                              onClick={(e) =>
                                handleChange(
                                  "location_services",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                        </div>
                        <div className="mt-3">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="p_notification"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Motion and Fitness
                            </label>
                            <input
                              checked={submitData?.motion_and_fitness}
                              type="checkbox"
                              id="p_notification"
                              className="notify-check"
                              onClick={(e) =>
                                handleChange(
                                  "motion_and_fitness",
                                  e.target.checked
                                )
                              }
                            />
                          </div>
                        </div>
                        <h3 className="notify-head blue-clr position-relative mt-5 fs-3 fw-bold lh-base">
                          Notifications
                        </h3>
                        <div className="mt-4">
                          <div className="toggle d-flex justify-content-between align-items-center">
                            <label
                              htmlFor="e_report"
                              className="blue-clr fs-4 fw-normal lh-base"
                            >
                              Notifications
                            </label>
                            <input
                              checked={submitData?.app_notifications}
                              type="checkbox"
                              id="e_report"
                              className="notify-check"
                              onClick={(e) =>
                                handleChange("app_notifications", e.target.checked)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-2 ps-lg-4 mt-5 mt-lg-0">
                      <div className="w-100 h-100 d-flex flex-column justify-content-center">
                        <p className="blue-clr fs-2 lh-base fw-normal text-center">
                          OR
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-5 ps-lg-4 mt-5 mt-lg-0">
                      <div>
                        <h3 className="notify-head blue-clr position-relative fs-3 fw-bold lh-base">
                          Rolling Adz GPS Device
                        </h3>
                      </div>
                      <div className="request-btn mt-5">
                        <button
                          type="button"
                          className="btn shadow-none rounded-pill w-100 fs-4 lh-base p-3"
                        >
                          Request
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col text-center mt-5 save-main">
                      <p className="blue-clr fs-5 mx-auto w-75 lh-sm">
                        Rolling Adz uses location services to match you with
                        advertisers where you regularly drive. To qualify for
                        campaigns, you will need to track at least 100 miles.
                      </p>
                      <button
                        type="submit"
                        className="btn_bgnone btn blue-clr fs-4 lh-base fw-normal"
                      >
                        <span className="pe-2">Save Changes</span>
                        <FaCheck />
                      </button>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};
